<template>
  <div class="accordion" v-bind:class="open === true ? 'open' : 'closed' ">
   <div @click="open = !open" class="accordion_head">
     <span>{{ title }}</span>
   </div>
   <div class="accordion_body" v-bind:class="open === true ? 'open' : 'closed' ">
     <slot></slot>
   </div>
  </div>
</template>

<script>
export default {
  props: [ 'title' ],
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      open: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




/** WEBPACK FOOTER **
 ** AccordionTab.vue?e3f1bd62
 **/